import React, { useEffect } from 'react';
import { IconButton } from '@material-ui/core';
import { Create as EditIcon, Delete as DeleteIcon } from '@material-ui/icons';
import Table from '../../../components/ClearingTable/Table';
import Button from '../../../components/Buttons/Button';
import AutoCompleteAccountNo from '../../../components/AutoComplete/AutoCompleteAccountNo';
import AutoCompleteCorrespondent from '../../../components/AutoComplete/AutoCompleteCorrespondent';
import SelectSystemCode from '../../../components/Dropdown/SelectSystemCode';
import Text from '../../../components/Typography/Text';
import TextField from '../../../components/Textfields/TextField';
// import DigitalCashRequestModal from './Components/DigitalCashRequestModal'
import WalletAddressBookModal from '../../../components/Modals/WalletAddressBookModal';
import {
  notifyInfo,
  notifyError,
  notifySuccess,
} from '../../../components/Messages/Notification';
import {
  listWalletAddressBook,
  createWalletAddressBook,
  updateWalletAddressBook,
  deleteWalletAddressBook,
} from '../../../services/WalletAddressBookService';
import {
  createRecurrence,
  updateRecurrence,
  deleteRecurrence,
} from '../../../services/RecurrenceService';
import QueryParam from '../../../services/QueryParamService';
import { getProfileName } from '../../../services/ProfileService';
import { getCurrentUser, getAccess } from '../../../services/AuthService';
import {
  getAccountInfo,
  getAccessibleClient,
} from '../../../services/ClientAccountService';
import {
  CustomBodyRenderCurrency,
  CustomBodyRenderAlign,
} from '../../../components/Table/CustomBodyRender';
import { columnType } from '../../../components/ClearingTable/CleanUpTable';

export default function WalletAddressBook() {
  const [rows, setRows] = React.useState([]);
  const [rowData, setRowData] = React.useState({});
  const [isEdit, setIsEdit] = React.useState(false);
  const [profileName, setProfileName] = React.useState('');
  const [addLoading, setAddLoading] = React.useState(true);

  const [defaultWallet] = React.useState([]);
  const [defaultAccount, setDefaultAccount] = React.useState([]);
  const [open, setOpen] = React.useState({
    add: false,
  });

  const [loading, setLoading] = React.useState({
    search: false,
    save: false,
  });

  const [searchData, setSearchData] = React.useState(
    QueryParam.get({
      nickName: '',
      correspondent: '',
      accountNo: '',
      status: 'Active',
    })
  );

  const handleSearchDataChange = (e) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    setSearchData({ ...searchData, [input.name]: input.value });
  };

  const handleSearch = async () => {
    try {
      setLoading({ ...loading, search: true });

      QueryParam.set(searchData);

      const data = await listWalletAddressBook(searchData);
      setRows(data.walletAddressBooksList);

      notifyInfo(
        data.walletAddressBooksList.length > 0
          ? data.walletAddressBooksList.length + ' search result(s)'
          : 'No records found.'
      );
    } catch (error) {
      notifyError(error.message);
      console.log(error);
      return;
    } finally {
      setLoading({ ...loading, search: false });
    }
  };

  const isDeleteEnabled = (data) => {
    if (data.status === 'Active') {
      return true;
    } else {
      return false;
    }
  };

  const handleDelete = async (data) => {
    try {
      await deleteWalletAddressBook(data.walletAddressBookId);
    } catch (error) {
      console.error(error);
      notifyError(error.message);
    } finally {
      notifySuccess('Wallet address book has been deactivated');
      handleSearch(false);
    }
  };

  const handleOpen = async (data) => {
    const correspondent = defaultAccount?.client?.correspondent
      ? defaultAccount.client?.correspondent
      : '';
    const account_no = defaultAccount?.client?.accountNo
      ? defaultAccount.client?.accountNo
      : '';
    const wallet_id = defaultWallet.length > 0 ? defaultWallet[0].walletId : '';
    if (!data) {
      data = {
        accountId: '',
        correspondent: correspondent,
        accountNo: account_no,
        contraWalletId: '',
        status: 'Active',
        walletId: wallet_id,
        walletAddressBookId: '',
        recurrenceAmount: '',
        nickName: '',
      };

      const reservedData = await createWalletAddressBook(data);
      data.walletAddressBookId = reservedData.walletAddressBook.walletAddressBookId;
      setIsEdit(false);
    } else {
      setIsEdit(true);
    }
    setRowData(data);
    setOpen({ add: true });
  };

  const validate = async (data, recData) => {
    let valid = true;

    if (
      data.recurrenceAmount &&
      data.recurrenceAmount !== '' &&
      data.recurrenceAmount !== 0 &&
      (recData.recurring === 'None' || recData.recurring === '')
    ) {
      notifyError('Recurring Pattern is required to enter recurrence amount');
      valid = false;
    }

    if (
      (!data.recurrenceAmount ||
        data.recurrenceAmount === '' ||
        data.recurrenceAmount === 0) &&
      recData.recurring !== 'None' &&
      recData.recurring !== ''
    ) {
      notifyError('Recurrence Amount is required for recurrence');
      valid = false;
    }

    if (data.correspondent === '' || !data.correspondent) {
      notifyError('Correspondent is required');
      valid = false;
    }
    if (data.accountNo === '' || !data.accountNo) {
      notifyError('Account No is required');
      valid = false;
    }
    if (data.walletId === '' || !data.walletId) {
      notifyError('Wallet Id is required');
      valid = false;
    }
    if (data.contraWalletId === '' || !data.contraWalletId) {
      notifyError('Contra wallet Id is required');
      valid = false;
    }
    if (data.status === '' || !data.status) {
      notifyError('Status is required');
      valid = false;
    }

    return valid;
  };

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const init = async () => {
    let account_no = '';
    let correspondent = '';
    try {
      const profileName = await getProfileName();
      const loggeduser = getCurrentUser();

      if (loggeduser.AccountId !== 0) {
        const account = await getAccountInfo();
        setDefaultAccount(account);
        account_no = account.accountNo;
        correspondent = account.correspondent;
      } else {
        const account = await getAccessibleClient(loggeduser.UserId);
        setDefaultAccount(account);
        account_no = account.client.accountNo;
        correspondent = account.client.correspondent;
      }

      if (!getAccess('account_no', loggeduser.UserType)) {
        setSearchData({
          ...searchData,
          accountNo: account_no,
          correspondent: correspondent,
        });
      }

      setProfileName(profileName.toLowerCase());
    } catch (error) {
      notifyError(error.message);
    }
    setAddLoading(false);
  };

  const columns = [
    {
      name: 'actions',
      label: 'Actions',
      type: columnType.buttons,
      options: {
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div className="grd-row nm">
              <div className="grd-cell nm">
                <IconButton aria-label="edit" onClick={() => handleOpen(rows[dataIndex])}>
                  <EditIcon style={{ height: 24, width: 24 }} />
                </IconButton>
              </div>
              <div className="grd-cell nm">
                <IconButton
                  disabled={!isDeleteEnabled(rows[dataIndex])}
                  aria-label="delete"
                  onClick={() => handleDelete(rows[dataIndex])}
                >
                  <DeleteIcon style={{ height: 24, width: 24 }} />
                </IconButton>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: 'accountId',
      label: 'Account ID',
      options: {
        customBodyRender: CustomBodyRenderAlign,
        display: false,
      },
    },
    {
      name: 'correspondent',
      label: 'Correspondent',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'accountNo',
      label: 'Account No',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'walletId',
      label: 'Wallet ID',
      options: {
        customBodyRender: CustomBodyRenderAlign,
        display: false,
      },
    },
    {
      name: 'contraWalletId',
      label: 'Contra Wallet ID',
      options: {
        customBodyRender: CustomBodyRenderAlign,
        display: false,
      },
    },
    {
      name: 'nickName',
      label: 'Nickname',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'recurrenceAmount',
      label: 'Recurrence Amount',
      type: columnType.amount,
      options: {
        customBodyRender: CustomBodyRenderCurrency,
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'recurring',
      label: 'Recurrence',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'a-selectAll',
      label: 'Select All',
      options: {
        display: true,
        print: false,
        download: false,
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            width: '0px',
            display: 'table-cell',
            padding: 0,
            pointerEvents: 'none',
            fontSize: 0,
          },
        }),
      },
    },
  ];

  const options = {
    selectableRows: 'none',
    responsive: 'standard',
  };

  const handleClose = async (data, recData, isEdit) => {
    if (!data) {
      setOpen(false);
      return;
    }
    const valid = await validate(data, recData);
    if (!valid) {
      return;
    }

    try {
      await updateWalletAddressBook(data);
      if (recData) {
        recData.linkId = data.walletAddressBookId;
        recData.functionName = 'Bank';
        recData.report = 'Wallet Address Book';
        if (recData.recurrenceId !== 0) {
          if (recData.recurring === 'None') {
            await deleteRecurrence(recData);
          } else {
            await updateRecurrence(recData);
          }
        } else {
          await createRecurrence(recData);
        }
      }

      handleSearch(false);

      if (isEdit) {
        notifySuccess(' Wallet Address Book has been updated.');
      } else {
        notifySuccess(' Wallet Address Book has been added.');
      }

      setOpen(false);
    } catch (error) {
      console.error(error);
      notifyError(error.message);
    }
  };

  return (
    <form className="page-c">
      <div className="search-c">
        <div className="grd-row nm">
          <div className="grd-cell">
            <Text mt={8} variant="h1" label="Wallet Address Book" />
          </div>
          <div className="grd-cell-none">
            <Button
              disabled={loading.search}
              loading={loading.search}
              type="search"
              label={loading.search ? 'Searching...' : 'Search'}
              onClick={handleSearch}
            />
          </div>
          <div className="grd-cell-none">
            <Button
              type="plus"
              label="Add Wallet Address Book"
              loading={addLoading}
              disabled={addLoading}
              onClick={() => handleOpen()}
            />
          </div>
        </div>
        <div className="grd-row">
          <div className="grd-cell">
            <TextField
              name="nickName"
              label="Nickname"
              placeholder="Nickname"
              type="text"
              value={searchData.nickName}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteCorrespondent
              name="correspondent"
              label="Correspondent"
              value={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteAccountNo
              name="accountNo"
              value={searchData.accountNo}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <SelectSystemCode
              name="status"
              label="Status"
              placeholder="Status"
              type="Status"
              subType="AI"
              value={searchData.status}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell"></div>
          <div className="grd-cell"></div>
        </div>
      </div>

      <div className="mt-20">
        <Table
          title={'Wallet Address Book'}
          data={rows}
          columns={columns}
          options={options}
        />
      </div>

      {open.add && (
        <WalletAddressBookModal
          data={rowData}
          open={open.add}
          profileName={profileName}
          close={handleClose}
          loading={loading.save}
          isEdit={isEdit}
        ></WalletAddressBookModal>
      )}
    </form>
  );
}
